/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left',
    suggestionMobileStyle: 'style2', // style1, style2
  }
};

(function() {
  BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }

  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    });

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  }); // End Clear button for the Form Search

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');
    });
  };

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');
    });
  };

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  // Modify the getTemplate function to customize the price display
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
    switch (tempType) {
      case InstantSearchResultItemProduct.tempType.IMAGE:
        return `
          <div class="{{class.searchSuggestion}}-left">
            <img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
          </div>
        `.trim();
      case InstantSearchResultItemProduct.tempType.SKU:
        return `
          <p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
        `.trim();
      case InstantSearchResultItemProduct.tempType.VENDOR:
        return `
          <p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
        `.trim();
      case InstantSearchResultItemProduct.tempType.PRICE:
        return `
          <p class="{{class.searchSuggestion}}-product-price">
            <span class="{{class.searchSuggestion}}-product-regular-price">{{priceRange}}</span>
          </p>
        `.trim();
      case InstantSearchResultItemProduct.tempType.PRICE_SALE:
        return `
          <p class="{{class.searchSuggestion}}-product-price">
            <span class="{{class.searchSuggestion}}-product-sale-price">{{priceRange}}</span>&nbsp;
            <s class="{{class.searchSuggestion}}-product-compare-price">{{compareAtPriceRange}}</s>
          </p>
        `.trim();
      default:
        return `
          <li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
            <a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
              {{itemProductImage}}
              <div class="{{class.searchSuggestion}}-right">
                <p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
                {{itemProductSku}}
                {{itemProductVendor}}
                {{itemProductPrice}}
              </div>
            </a>
          </li>
        `.trim();
    }
  };

  // Modify the compileSuggestionProductPrice function to calculate price ranges
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();

    // Get min and max prices
    var priceMin = this.data.price_min;
    var priceMax = this.data.price_max;
    var compareAtPriceMin = this.data.compare_at_price_min;
    var compareAtPriceMax = this.data.compare_at_price_max;

    // Check if product is on sale
    var onSale = compareAtPriceMin > priceMin;

    // Format prices
    var priceMinFormatted = Utils.formatMoney(priceMin);
    var priceMaxFormatted = Utils.formatMoney(priceMax);
    var compareAtPriceMinFormatted = Utils.formatMoney(compareAtPriceMin);
    var compareAtPriceMaxFormatted = Utils.formatMoney(compareAtPriceMax);

    // Remove decimals if setting is enabled
    if (Settings.getSettingValue('search.removePriceDecimal')) {
      priceMinFormatted = Utils.removeDecimal(priceMinFormatted);
      priceMaxFormatted = Utils.removeDecimal(priceMaxFormatted);
      compareAtPriceMinFormatted = Utils.removeDecimal(compareAtPriceMinFormatted);
      compareAtPriceMaxFormatted = Utils.removeDecimal(compareAtPriceMaxFormatted);
    }

    // Construct price range
    var priceRange = '';
    if (priceMin == priceMax) {
      priceRange = priceMinFormatted;
    } else {
      priceRange = priceMinFormatted + ' - ' + priceMaxFormatted;
    }

    // Construct compare at price range if available
    var compareAtPriceRange = '';
    if (compareAtPriceMin > 0 && compareAtPriceMax > 0) {
      if (compareAtPriceMin == compareAtPriceMax) {
        compareAtPriceRange = compareAtPriceMinFormatted;
      } else {
        compareAtPriceRange = compareAtPriceMinFormatted + ' - ' + compareAtPriceMaxFormatted;
      }
    }

    // Build the price HTML
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
      if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice') && compareAtPriceRange) {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
      } else {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
      }
    }

    return result
      .replace(/{{priceRange}}/g, priceRange)
      .replace(/{{compareAtPriceRange}}/g, compareAtPriceRange);
  };

})();
